import type { TableColumnConfig, TableStickyColumns } from '@ipfabric/utils';

export const makeIsColumnSticky =
  (stickyColumns: TableStickyColumns | undefined) =>
  (column: TableColumnConfig): boolean =>
    stickyColumns?.[column.key] ?? column.sticky ?? false;
